/* eslint-disable import/prefer-default-export */

// TODO: remove `/wp` from all the paths after testing
export const WORDPRESS_PATHS = Object.freeze({
  BLOG_ROUTE: '/wp/blog',
  BLOGS: '/wp/blog/:year?/:month?/:day?/:post?',
  GUIDES: '/wp/sell-my-car/guides',
});
